import { useEffect } from 'react'
import Dropdown from '@/components/Dropdown/index'
import PropTypes from 'prop-types'

const parseJson = value => {
  if (typeof value === 'string') {
    try {
      return JSON.parse(value)
    } catch {
      return value
    }
  }
  return value
}

const CellDropdownComponent = ({
  isReadOnly,
  schema,
  payload,
  parentProps,
  inputProps,
  setInputProps,
  updatePayload,
  validateSchema,
  getFieldValue,
}) => {
  const options = () => {
    if (schema['x-uioptions']) {
      const value = parseJson(schema['x-uioptions'])
      return value.map((v, index) => ({ value: v.value, label: v.label, index }))
    }
    return []
  }

  useEffect(() => {
    setInputProps({
      ...inputProps,
      disabled: isReadOnly,
      value: getFieldValue(payload, parentProps),
    })
  }, [payload])

  function onClick(value, label) {
    if (isReadOnly) return
    setInputProps({ ...inputProps, value, label })
    updatePayload(value)
    validateSchema(value)
  }

  return (
    <Dropdown
      placeholder={isReadOnly ? null : 'Select Option'}
      value={options().find(option => option.value === inputProps?.value)?.label}
      disabled={isReadOnly}
    >
      {options().map(({ label, value, index }) => (
        <Dropdown.Item key={index} id={label} onClick={() => onClick(value, label)} value>
          {label}
        </Dropdown.Item>
      ))}
    </Dropdown>
  )
}

CellDropdownComponent.propTypes = {
  isReadOnly: PropTypes.bool,
  schema: PropTypes.object,
  payload: PropTypes.object,
  parentProps: PropTypes.array,
  inputProps: PropTypes.object,
  setInputProps: PropTypes.func,
  updatePayload: PropTypes.func,
  validateSchema: PropTypes.func,
  getFieldValue: PropTypes.func,
}

export default CellDropdownComponent
